/* global G */
import { asyncPipeSpread } from 'lib/util'
import find from 'lib/sequence/component/children/find'
import { updateList } from 'app/notification/action/partials/updateList'

/**
 * Notification Alerts Action
 *
 * @param {Gaia.AppModule.Spec} module current module composition
 * @returns {function(*): function(...[*]): Promise<*[]>}
 */
export default module => () => async (...args) => asyncPipeSpread(
  updateList('alert')(module),
)(find(module[G.STATE][G.ACTION][G.COMPONENT]), ...args)
